import { render, staticRenderFns } from "./OpenGather.vue?vue&type=template&id=6a88234f"
import script from "./OpenGather.vue?vue&type=script&lang=js"
export * from "./OpenGather.vue?vue&type=script&lang=js"
import style0 from "./OpenGather.vue?vue&type=style&index=0&id=6a88234f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports